module.exports = __webpack_public_path__ + "img/mostaza.eb85c754.svg";